import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";
import Utils from "../../utils/Utils";

export const Scores = ({ show = true }) => {
  const router = useRouter();
  return (
    <div className="container stats-explained">
      <div className="text-left">
        <h2>Scores</h2>
        <h5>How exactly does the Scores tool work?</h5>
      </div>
      <div className="text-left" style={{ display: "flex", flexDirection: "column" }}>
        <p>
          <b style={{ color: "#d07c3b" }}>Scores</b> are the day-to-day look at both past and future games. Past games
          show final scores along with SQ Score and expected win percent, denoting unexpected winners in yellow. Future
          games show predictions and the chance ShotQuality gives each team to win. From each Score, the links to each
          team and game/matchup page can be easily accessed.
        </p>

        <Image
          src={Utils.getAsset("ScoresToolPreview.png")}
          alt="picture showing how the scores tool works"
          className="rounded"
        />

        <a
          href={`/scores`}
          target={"_blank"}
          style={{
            padding: "15px 50px",
            width: "200px",
            alignSelf: "center",
            marginTop: "15px",
          }}
          className="btn btn-orange"
        >
          Go to the Tool
        </a>
      </div>
    </div>
  );
};
